/* eslint-disable */
import { useRef, useEffect } from "react";

export default function useEffectSkipFirst(fn: any, arr: any) {
	const isFirst = useRef(true);

	useEffect(() => {
		if (isFirst.current) {
			isFirst.current = false;

			return;
		}

		return fn();
	}, arr);
}
